import { Box } from '@mui/material';
import React from 'react';

import FooterImage from '../_assets/footer.svg?styled';

export type FooterProps = {
  // Empty
};

export const Footer: React.FC<FooterProps> = () => {
  return (
    <>
      <FooterImage />
      <Box
        sx={{
          mt: -2,
          mb: -2,
          height: { xs: 120, lg: 0 },
          backgroundColor: (theme) => theme.palette.background.contrast,
        }}
      />
    </>
  );
};
